<template>
  <div class="page-list">
    <van-list v-if="dataList && dataList.length > 0" v-model="state.loading" :finished="state && state.finished"
              :finished-text="state.finishText"
      :immediate-check="false" :offset="50" @load="getDataBaseList({})">
      <div class="train-list">
        <div class="train-item" v-for="(item, index) in dataList" :key="index" @click="gotoDetails(item)">
          <div class="tag status2" v-if="item.status === '1'">
            {{ item && item.statusText }}
          </div>
          <div class="tag status1" v-if="item.status === '2'">
            {{ item && item.statusText }}
          </div>
          <div class="tag status3" v-if="item.status === '3'">
            {{ item && item.statusText }}
          </div>
          <div class="tag status4" v-if="item.publishStatus === '3'">
            {{ item && item.statusText }}
          </div>
          <div class="flex-item">
            <img v-if="item && item.coverMaterial" :src="item && item.coverMaterial.url" alt="" class="item-cover" />
            <div v-else class="item-cover"></div>
            <div class="item-cons">
              <div class="cons-info-txt">
                {{ item && item.title }}
              </div>
              <div class="flex-div">
                <div class="con-info-tag">{{ item && item.onlineStatusName }}</div>
                <div class="con-info-tag" v-if="item.studentCode === 'Y' || item.lecturerCode === 'Y'">
                  {{
                    item.studentCode === 'Y'
                    ? '参会人'
                    : item.lecturerCode === 'Y'
                      ? '主讲人'
                      : ''
                  }}
                </div>
              </div>
              <div class="con-info-txt2" v-if="item && item.hospital" :class="
                userInfo.hospitalId === item.hospital.id ? 'hasCode' : ''
              ">
                {{ item && item.hospital.cnName }}
              </div>
              <div class="con-info-txt2" v-if="item && item.hospital">{{ item.hospital.address }}</div>
              <div class="con-info-txt4">
                <img src="../../../assets/images/train/icon_date.png" class="icon-date" alt="" />
                {{ item && item.startTxt }} -
                {{ item && item.endTimeTxt }}
              </div>
            </div>
          </div>

          <!--
            certificateNo === 4，就是大主任，就不能签到评价，只能看，
            certificateNo === 5，大主任学员，如果被选为学员的话就可以进行签到，评价
            item.directorStudentSgin === 'Y'，被选为学员，可以进行签到评价
            item.publishStatus !== 3，判断该活动有没有被取消
            item.studentSpeakerSign === 'N'，判断是不是被选为主讲人
            roleTypes === 4，登录的角色为学员
            item.trainingType === 'offline' || item.trainingType === 'meeting'，线下活动和ZOOM会议链接，
          -->
          <div class="item-btm">
            <template
              v-if="item.publishStatus !== '3' && item.studentCode === 'Y'">
              <div class="btn-txt cur" v-if="
                item.isSign === 'N' &&
                ((item.isTimeSign === 'Y' && (item.status === '2' || item.status === '3')) || item.status === '1')" @click.stop="singup(item, index)">
                签到
              </div>
              <div class="btn-txt" v-else-if="item.isSign === 'Y'">
                已签到
              </div>
              <!-- <div class="btn-txt" v-else-if="item.isSign === 'N' && item.status === '3'">
                未签到
              </div> -->
              <div class="btn-txt btn-status-txt" @click.stop="gotoLine(item)" v-if="
                ((item.isTimeSign === 'Y' && item.status === '2') || item.status === '1') &&
                item.onlineStatus === '1'
              ">
                进入会议
              </div>
              <div class="btn-txt cur" @click.stop="gotoEva(item)" v-if="
                item.isEvaluate === 'N' &&
                item.status !== '2'
              ">
                评价
              </div>
              <div class="btn-txt cur" @click.stop="gotoEva(item)" v-else-if="
                item.isEvaluate === 'Y' &&
                item.status !== '2'
              ">
                查看评价
              </div>
            </template>
            <template v-if="item.lecturerCode === 'Y' && item.studentCode === 'N'">
              <div class="btn-txt" v-if="item.avgScore > 0">
                <img src="../../../assets/images/train/pic_stars_s@2x.png" class="start" alt="" />
                <div class="start-num">{{ item.avgScore }} 分</div>
              </div>
              <div class="btn-txt btn-status-txt" @click.stop="gotoLine(item)" v-if="
                ((item.isTimeSign === 'Y' && item.status === '2') || item.status === '1') &&
                item.onlineStatus === '1'
              ">
                进入会议
              </div>
            </template>
          </div>
        </div>
      </div>
    </van-list>
    <div class="empty-view" v-if="state.showEmptyView">
      <img class="empty-image" src="../../../assets/images/train/img_none.png" />
      <div class="empty-txt">
        <div class="txt-title">暂无活动</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTrainList, trainSingUp } from '../../../api/train.js'
import { Toast } from 'vant'
import router from '../../../router'
import {handleTraceSearchLog} from '../../../utils/trace'
export default {
  name: 'TrainList',
  data () {
    return {
      dataList: [],
      state: {
        pageNo: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '已经到底了',
        showEmptyView: false,
      },
      searchParams: {}
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    // console.log(11111)
    // this.handleDefault({})
  },
  methods: {
    handleDefault(data) {
      if (window && window.sessionStorage.getItem('trainFilter')) {
        let params = JSON.parse(window.sessionStorage.getItem('trainFilter')).params
        this.getDataBaseList(params)
        return
      }
      this.getDataBaseList(data)
    },
    gotoLine (TrainData) {
      if (TrainData.status === '1') {
        window.location.href = TrainData.liveLink
      }
    },
    getDataBaseList (searchParams) {
      // 做一个判断
      if (searchParams.search) {
        this.dataList = []
        this.state.pageNo = 1
        handleTraceSearchLog({
          'userId': this.userInfo.id,
          'searchContent': searchParams.title,
          'sessionId': localStorage.getItem('sessionId'),
          'type': 6,
          'entrance': 13,
        })
      }
      // 删除判断
      searchParams.search && delete searchParams.search
      this.searchParams = searchParams
      let params = {
        pageNum: this.state.pageNo,
        pageSize: this.state.pageSize,
        title: this.searchValue,
        iepUserId: this.userInfo.id,
        multiCode: this.userInfo.multiCode,
        queryAll: 'Y'
      }
      if (this.$route.query.activityStatusSign) {
        params.activityStatusSign = 'Y'
      }
      params = Object.assign(params, searchParams)
      let tempSearchParams = searchParams
      delete tempSearchParams.title
      delete tempSearchParams.hospitalMark
      if (Object.keys(tempSearchParams).length > 0) {
        delete params.queryAll
      }
      this.state.loading = true
      getTrainList(params)
        .then((res) => {
          res.data.list.map((itm) => {
            itm.startTxt = this.$moment(parseInt(itm.startTime)).format('YYYY-MM-DD HH:mm')
            itm.endTimeTxt = this.$moment(parseInt(itm.endTime)).format('MM-DD HH:mm')
            itm.statusText = ''
            if (itm.publishStatus === '2') {
              switch (itm.status) {
                case '1':
                  itm.statusText = '进行中'
                  break
                case '2':
                  itm.statusText = '待开始'
                  break
                case '3':
                  itm.statusText = '已完成'
                  break
              }
            } else if (itm.publishStatus === '3') {
              itm.statusText = '已取消'
            }
            return itm
          })
          if (this.dataList.length > 0) {
            this.dataList = this.dataList.concat(res.data.list)
          } else if (this.dataList.length === 0) {
            this.dataList = res.data.list ? res.data.list : []
          }
          this.state.finished = this.dataList.length >= res.data.total
          // 加载状态结束
          this.state.loading = false
          if (this.state.pageNo !== 1) {
            this.state.finishText = '已经到底了'
          } else {
            this.state.finishText = ''
          }
          this.state.showEmptyView = this.dataList.length <= 0
          this.state.pageNo++
        })
        .catch((err) => {
          this.dataList = []
          Toast(err.msg ? err.msg : '获取失败')
        })
    },
    singup (item, index) {
      trainSingUp({
        studentMultiCode: this.userInfo.multiCode,
        academicActivityId: item.id,
        signTime: new Date().getTime(),
        iepUserId: this.userInfo.id
      })
        .then(() => {
          Toast('签到成功')
          this.state.pageNo = 1
          this.dataList = []
          this.getDataBaseList(this.searchParams)
        })
        .catch((err) => {
          Toast(err.msg ? err.msg : '请求失败')
        })
    },
    gotoDetails (item) {
      router.push({
        path: '/train/trainDetails',
        query: {
          trainId: item.id,
          hospitalId: item.hospital ? item.hospital.id : ''
        }
      })
    },
    gotoEva (item) {
      router.push({
        path: '/train/evaluate',
        query: {
          trainId: item.id,
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.train-list {
  box-sizing: border-box;

  .train-item {
    background-color: #fff;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    padding: 16px 12px 0;
    box-sizing: border-box;
    margin-bottom: 8px;

    .flex-item {
      display: flex;

      .item-cover {
        width: 118px;
        height: 70px;
        border-radius: 6px;
        object-fit: cover;
        margin-right: 13px;
      }

      .item-cons {
        .cons-info-txt {
          width: 170px;
          font-size: 12px;
          color: #2b2b2b;
          font-weight: 500;
          line-height: 17px;
          margin-bottom: 4px;
          display: -webkit-box;
          /* 盒子类型 */
          word-break: break-all;
          /* 自动换行的处理方法。允许在单词内换行 */
          text-overflow: ellipsis;
          /* 溢出时用... */
          overflow: hidden;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          /* 最大行数 */
        }

        .flex-div {
          display: flex;
          align-items: center;
        }

        .con-info-tag {
          background-color: #fff;
          border-radius: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 4px;
          font-size: 10px;
          color: #EB1700;
          border: 1px solid #EB1700;
          padding: 1px 3px;
          width: 42px;
          height: 14px;
          margin-right: 8px;
        }

        .con-info-txt2 {
          color: #5b5f6a;
          font-size: 10px;
          line-height: 14px;
          margin-bottom: 8px;

          &.hasCode {
            color: #EB1700;
          }
        }

        .con-info-txt4 {
          display: flex;
          color: #5b5f6a;
          font-size: 10px;
          line-height: 14px;
          align-items: center;
          margin-bottom: 4px;

          .icon-date {
            width: 8px;
            height: 8px;
            margin-right: 4px;
          }
        }
      }
    }

    .item-btm {
      display: flex;
      justify-content: flex-end;
      border-top: 0.5px solid #e0e2e7;
      height: 34px;
      align-items: center;
      width: 351px;
      margin-left: -12px;
      padding: 0 12px;
      box-sizing: border-box;

      &.line-btn {
        .btn-txt {
          background-color: #EB1700;
          color: #fff;
          width: 90px;
          height: 20px;
          font-size: 12px;
          border-radius: 100px;
        }
      }

      .item-icon {
        width: 12px;
        height: 12px;
        margin-right: 3px;
      }

      .btn-txt {
        font-size: 12px;
        color: #5b5f6a;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 12px;

        &.cur {
          padding: 1px 10px;
          box-sizing: border-box;
          color: #FFF;
          background: #EB1700;
          border-radius: 100px;
        }

        &.no_cur {
          border-radius: 100px;
          padding: 1px 10px;
          box-sizing: border-box;
          color: #5b5f6a;
          border: 0.5px solid #5b5f6a;
        }

        &.btn-status-txt {
          background-color: #EB1700;
          color: #fff;
          border-radius: 100px;
          width: 68px;
          height: 20px;
          line-height: 20px;
          text-align: center;
        }

        .start {
          width: 14px;
          height: 14px;
        }

        .start-num {
          font-size: 12px;
          color: #2b2b2b;
          margin-left: 3px;
        }
      }
    }

    .tag {
      position: absolute;
      top: 0;
      right: 0;
      border-bottom-left-radius: 12px;
      border-top-right-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 10px;
      width: 42px;
      height: 20px;

      &.status1 {
        background-color: #FF6017;
      }

      &.status2 {
        background-color: #EB1700;
      }

      &.status3 {
        background-color: #328714;
      }

      &.status4 {
        background-color: #D5CFC9;
      }
    }
  }
}

.empty-view {
  .empty-image {
    position: absolute;
    width: 120px;
    height: 104px;
    top: 188px;
    left: 50%;
    transform: translateX(-50%);
  }

  .txt-title {
    position: absolute;
    text-align: center;
    font-size: 14px;
    top: 304px;
    color: #5b5f6a;
    width: 100%;
    left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/academicActivities/components/TrainList.vue